import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import CleanTeamHeader from "@/components/CleanTeamHeader";
import CleanTeamHero from "@/components/CleanTeamHero";
import TeamGrid from "@/components/TeamGrid";
import JerseyModal from "@/components/JerseyModal";
import CleanTeamFooter from "@/components/CleanTeamFooter";

const useSmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
};

const Home = () => {
  const [selectedTeam, setSelectedTeam] = useState(null);
  return (
    <div className="min-h-screen bg-[#07090E]" data-testid="cleanteam-app">
      <CleanTeamHeader />
      <main>
        <CleanTeamHero />
        <TeamGrid onSelect={setSelectedTeam} />
        <CleanTeamFooter />
      </main>
      {selectedTeam && <JerseyModal team={selectedTeam} onClose={() => setSelectedTeam(null)} />}
    </div>
  );
};

function App() {
  useSmoothScroll();
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
